// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pin-dialog[data-v-7072b8ae]{color:var(--c-black);font-size:15px;padding:15px 15px 0}.pin-dialog__form[data-v-7072b8ae]{display:flex;flex-direction:column;gap:15px}.pin-dialog__pin[data-v-7072b8ae]{width:200px}.button[data-v-7072b8ae]{margin:20px 0 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
